import { render, staticRenderFns } from "./WagtailPage.vue?vue&type=template&id=bb7236cc&scoped=true&"
import script from "./WagtailPage.vue?vue&type=script&lang=js&"
export * from "./WagtailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7236cc",
  null
  
)

export default component.exports